/** First-touch commerce attribution (#168). No analytics events or discount codes. */
(() => {
  const STORAGE_KEY = 'naturah:attribution';
  const CART_KEY = 'naturah:attribution:cart-written';
  const CART_TIMEOUT_MS = 5000;
  const FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'];

  function read(key) {
    try { return sessionStorage.getItem(key); } catch { return null; }
  }
  function write(key, value) {
    try { sessionStorage.setItem(key, value); } catch { /* This page still works without storage. */ }
  }
  // Campaign labels only: never collect email, full URLs, arbitrary query fields or tag delimiters.
  function label(value) {
    if (typeof value !== 'string') return '';
    const normalized = value.trim().toLowerCase().replace(/_/g, '-');
    return normalized.length <= 100 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(normalized) ? normalized : '';
  }
  function clean(values) {
    return Object.fromEntries(FIELDS.map((field) => [field, label(values?.[field])]));
  }

  let attribution;
  try { attribution = clean(JSON.parse(read(STORAGE_KEY))); } catch { /* Discard malformed storage. */ }
  if (!attribution?.utm_source && !attribution?.ref) {
    const landing = clean(Object.fromEntries(new URLSearchParams(location.search)));
    if (landing.utm_source || landing.ref) {
      attribution = landing;
      write(STORAGE_KEY, JSON.stringify(attribution));
    }
  }
  const source = attribution?.utm_source || attribution?.ref;
  if (!source) return;

  function appendTags(form) {
    if (!(form instanceof HTMLFormElement) ||
        form.elements.namedItem('form_type')?.value !== 'customer') return;
    // Native radios share a name but only the checked radio is submitted. Update
    // their existing values too; adding a hidden field would submit duplicate tags.
    form.querySelectorAll('[name="contact[tags]"]').forEach((input) => {
      const tags = input.value.split(',').map((tag) => tag.trim())
        .filter((tag) => tag && !tag.startsWith('src-'));
      input.value = [...new Set(tags), `src-${source}`].join(',');
    });
  }
  function refreshForms() { document.querySelectorAll('form').forEach(appendTags); }
  refreshForms();
  // Capture before Shopify/hCaptcha serializes; popup choices can replace tags.
  document.addEventListener('submit', (event) => appendTags(event.target), true);
  document.addEventListener('change', refreshForms);
  document.addEventListener('click', refreshForms);
  new MutationObserver(refreshForms).observe(document.body, { childList: true, subtree: true });

  let written = read(CART_KEY) === '1';
  let pending;
  function syncCart() {
    if (written) return Promise.resolve();
    if (pending) return pending;
    const root = window.Shopify?.routes?.root || '/';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), CART_TIMEOUT_MS);
    pending = fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      signal: controller.signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { source, campaign: attribution.utm_campaign } })
    }).then((response) => {
      if (response.ok) {
        written = true;
        write(CART_KEY, '1');
      }
    }).catch(() => { /* A later successful add retries; attribution never blocks shopping. */ })
      .finally(() => {
        clearTimeout(timeout);
        pending = null;
      });
    return pending;
  }
  window.NaturahAttribution = { syncCart };
})();
